import {createFileRoute} from '@tanstack/react-router';

import {ProjectTypesPage} from '@/modules/admin-settings/pages/ProjectTypesPage';

export const Route = createFileRoute('/_authenticated/admin/settings/project-types/')({
  component: ProjectTypesPage,
});
